import * as React from 'react';

import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { HtmlToTextParser } from '../../../../../components/HtmlParser';
import { theme } from '../../../../theme';
import { ExtendedProjectTask } from './types';

const ProjectTaskDataGrid: React.FC<{
	tasks: ExtendedProjectTask[];
	filterName: string;
	filterTags: string[];
	onRowSelect: (item: ExtendedProjectTask) => void;
}> = ({ tasks, filterName, filterTags, onRowSelect }) => {
	const columns: GridColDef[] = [
		{ field: 'customerName', headerName: 'Asiakas', width: 200 },
		{ field: 'projectTaskName', headerName: 'Tehtävän nimi', width: 200 },
		{
			field: 'instrumentName',
			headerName: 'Instrumentti',
			width: 200,
			// valueGetter: (params: any, item: ExtendedProjectTask) => {
			// 	if (item?.instrumentId) {
			// 		return `${item?.instrumentName} - ${item?.instrumentProvider ?? 'Oma'}`;
			// 	} else {
			// 		return '-';
			// 	}
			// },
		},
		{
			field: 'author',
			headerName: 'Tekijä',
			width: 200,
		},
		{
			field: 'instrumentProvider',
			headerName: 'Palveluntarjoaja',
			width: 200,
			// valueGetter: (params: any, item: ExtendedProjectTask) => {
			// 	if (item?.instrumentId) {
			// 		return `${item?.instrumentName} - ${item?.instrumentProvider ?? 'Oma'}`;
			// 	} else {
			// 		return '-';
			// 	}
			// },
		},
		{ field: 'projectTaskCategory', headerName: 'Category', width: 150 },
		{
			field: 'tags',
			headerName: 'Tags',
			width: 200,
			valueGetter: (params: any, item: ExtendedProjectTask) => {
				if (item?.tagsArray) {
					return item?.tagsArray.join(', ');
				} else if (item?.tags) {
					return item?.tags;
				} else {
					return '';
				}
			},
		},
		{
			field: 'startDate',
			headerName: 'Start Date',
			width: 150,
			valueGetter: (params: any, item: ExtendedProjectTask) =>
				item?.startDate ? new Date(item?.startDate).toLocaleDateString() : '',
		},
		{
			field: 'endDate',
			headerName: 'End Date',
			width: 150,
			valueGetter: (params: any, item: ExtendedProjectTask) => (item?.endDate ? new Date(item?.endDate).toLocaleDateString() : ''),
		},
		{
			field: 'projectTaskDescription',
			headerName: 'Kuvaus',
			width: 800,
			renderCell: (params: any) => (
				<Box sx={{ height: '8rem', overflow: 'auto' }}>{HtmlToTextParser(params.row.projectTaskDescription)}</Box>
			),
		},
	];

	const filteredTasks = tasks.filter(task => {
		const matchesNameOrDescription =
			filterName === '' ||
			(task.customerName ? task.customerName.toLowerCase().includes(filterName.toLowerCase()) : false) ||
			(task.projectTaskName ? task.projectTaskName.toLowerCase().includes(filterName.toLowerCase()) : false) ||
			(task.projectTaskDescription ? task.projectTaskDescription.toLowerCase().includes(filterName.toLowerCase()) : false);

		const matchesTags =
			!filterTags ||
			filterTags.length === 0 ||
			task.tagsArray?.some(taskTag => filterTags.some(filterTag => taskTag.toLowerCase().includes(filterTag.toLowerCase())));

		return matchesNameOrDescription && matchesTags;
	});

	return (
		<Box sx={{ height: '100%' }}>
			<DataGrid
				rows={filteredTasks}
				columns={columns}
				getRowId={row => row.projectTaskId}
				onRowClick={({ row }) => onRowSelect(row)}
				slots={
					{
						//toolbar: GridToolbar,
					}
				}
				initialState={{
					columns: {
						columnVisibilityModel: {
							endDate: false,
							startDate: false,
							projectTaskCategory: false,
							instrumentProvider: false,
						},
					},
				}}
				slotProps={{
					basePopper: {
						placement: 'bottom-end',
						style: { zIndex: 22000 },
					},
				}}
				disableColumnFilter={false}
				disableColumnSelector={false}
				disableDensitySelector={false}
				getRowHeight={() => 'auto'}
				sx={{
					'.MuiDataGrid-cell:focus': {
						outline: 'none',
					},
					'& .MuiDataGrid-row': {},
					'& .MuiDataGrid-row:hover': {
						cursor: 'pointer',
						background: theme.palette.grey[100],
					},
				}}
			/>
		</Box>
	);
};

export default ProjectTaskDataGrid;
